class PhilosophySlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.pauseBtn = this.querySelector('[data-slider-pause]');
    this.nextBtn = this.querySelector('[data-slider-next]');
    this.dots = [...this.querySelectorAll('[data-dot]')];

    if (!this.track || !this.pauseBtn || !this.nextBtn || !this.dots.length) return;

    this.INTERVAL = parseInt(this.dataset.interval, 10) || 3000;
    this.TOTAL = this.dots.length;
    this.currentIndex = 0;
    this.autoSlideTimer = null;

    this._onNext = () => {
      this.goToSlide(this.currentIndex + 1);
      if (!this.hasAttribute('data-paused')) this.startAutoSlide();
    };

    this._onPause = () => {
      if (this.hasAttribute('data-paused')) {
        this.removeAttribute('data-paused');
        this.pauseBtn.setAttribute('aria-label', 'Pause slideshow');
        this.startAutoSlide();
      } else {
        this.setAttribute('data-paused', '');
        this.pauseBtn.setAttribute('aria-label', 'Resume slideshow');
        this.stopAutoSlide();
      }
    };

    this._dotListeners = this.dots.map((dot, i) => {
      const handler = () => {
        this.goToSlide(i);
        if (!this.hasAttribute('data-paused')) this.startAutoSlide();
      };
      dot.addEventListener('click', handler);
      return handler;
    });

    this.nextBtn.addEventListener('click', this._onNext);
    this.pauseBtn.addEventListener('click', this._onPause);

    this.goToSlide(0);

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.hasAttribute('data-paused')) this.startAutoSlide();
          } else {
            this.stopAutoSlide();
          }
        });
      },
      { threshold: 0.2 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.stopAutoSlide();
    this.observer?.disconnect();
    this.nextBtn?.removeEventListener('click', this._onNext);
    this.pauseBtn?.removeEventListener('click', this._onPause);
    this.dots?.forEach((dot, i) => {
      dot.removeEventListener('click', this._dotListeners[i]);
    });
  }

  goToSlide(index) {
    this.currentIndex = ((index % this.TOTAL) + this.TOTAL) % this.TOTAL;
    this.track.style.setProperty('--slide-offset', this.currentIndex);
    this.dots.forEach((dot, i) => {
      if (i <= this.currentIndex) {
        dot.setAttribute('data-active', '');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.removeAttribute('data-active');
        dot.setAttribute('aria-selected', 'false');
      }
    });
  }

  startAutoSlide() {
    this.stopAutoSlide();
    this.autoSlideTimer = setInterval(() => {
      this.goToSlide(this.currentIndex + 1);
    }, this.INTERVAL);
  }

  stopAutoSlide() {
    if (this.autoSlideTimer !== null) {
      clearInterval(this.autoSlideTimer);
      this.autoSlideTimer = null;
    }
  }
}

customElements.define('philosophy-slider', PhilosophySlider);
